<template>
  <div class="field-dict-lazy-list" v-loading="loading" @scroll="scrollChange">
    <div class="field-dict-empty-text" v-if="dictValue.length < 1">暂无分类</div>
    <div class="field-dict-ul" v-else :style="ulStyle">
      <div
        class="field-dict-li"
        v-for="(dictItem, dictIdx) in dictValueProxy"
        :key="`${scrollLimit.first + dictIdx}`"
        :class="haveTools && 'have-tools'"
        @click="tapHandle(dictItem)"
      >
        <div class="field-dict-li-label single-ellipsis">{{ dictItem.labelName }}</div>
        <div class="field-dict-li-tools" v-if="haveTools">
          <slot name="tools" :dictItem="dictItem"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { services } from '@/service';
export default {
  data() {
    return {
      loading: false,
      dictValue: [],
      curScrollTop: 0
    };
  },
  props: {
    fieldItem: {
      type: Object,
      default: () => null
    },
    haveTools: {
      type: Boolean,
      default: false
    },
    defaultDictValue: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    itemHeight() {
      // 修改需要同步修改css
      return 28;
    },
    limitNum() {
      return 30;
    },
    contentHeight() {
      return this.limitNum * this.itemHeight;
    },
    ulHeight() {
      return this.itemHeight * this.dictValue.length;
    },
    scrollLimit() {
      let first = 0;

      if (this.dictValue.length > this.limitNum) {
        first = Math.floor(this.curScrollTop / 28) - 5;
        if (first < 0) {
          first = 0;
        }
      }

      let last = first + this.limitNum;
      if (last > this.dictValue.length) {
        last = this.dictValue.length;
      }

      return { first, last };
    },
    ulStyle() {
      const top = this.scrollLimit.first * this.itemHeight;
      let bottom = this.ulHeight - this.contentHeight - top;
      if (bottom < 0) {
        bottom = 0;
      }
      return { paddingTop: `${top}px`, paddingBottom: `${bottom}px` };
    },
    dictValueProxy() {
      return this.dictValue.slice(this.scrollLimit.first, this.scrollLimit.last);
    }
  },
  mounted() {
    if (this.fieldItem) {
      this.fetchDictHandle();
    } else {
      this.dictValue = Object.freeze(this.defaultDictValue);
    }
  },
  methods: {
    scrollChange(e) {
      this.curScrollTop = e.target.scrollTop;
    },
    async fetchDictHandle() {
      try {
        this.loading = true;
        const { data } = await services.caseRule.getFieldDictVal({
          labelId: this.fieldItem._id,
          keyword: '',
          courseId: '',
          size: 10000
        });
        this.dictValue = Object.freeze(data.dict_classify_value || []);
      } catch (err) {
        this.$error(err);
      } finally {
        this.loading = false;
      }
    },
    // 提供给 fieldsEditor 获取
    getDictValueForParent() {
      return this.dictValue;
    },
    tapHandle(item) {
      if (!this.haveTools) {
        this.$emit('tap', item);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.field-dict-lazy-list {
  max-height: 160px;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  .field-dict-empty-text {
    text-align: center;
    padding: 30px;
    color: #9599a5;
    font-size: 12px;
    font-weight: 350;
  }

  .field-dict-ul {
    .field-dict-li {
      display: flex;
      align-items: center;
      height: 28px;
      color: #2c3443;
      font-size: 12px;
      padding: 0 22px;

      .field-dict-li-label {
        flex: 1;
        width: 0;
      }

      .field-dict-li-tools {
        margin-left: 6px;
        opacity: 0;
      }

      &.have-tools {
        &:hover {
          background-color: #eaf6ff;
          .field-dict-li-tools {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
